import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type CgmDataSamplePayload = {
  status?: number;
  type?: number;
  rate?: number;
  rssi?: number;
  value?: number;
  timestamp?: number;
};

export type CGMDexcomDataEvent = {
  status?: number;
  type?: number;
  rate?: number;
  rssi?: number;
  value?: number;
  timestamp?: number;
  transmitterTimestamp?: number;
};

const cgmDataSampleSchema = z.object({
  status: cz.permissive(z.number()),
  type: cz.permissive(z.number()),
  rate: cz.permissive(z.number()),
  rssi: cz.permissive(z.number()),
  value: cz.permissive(z.number()),
  timestamp: cz.permissive(z.number()),
});

export const LID_CGM_DATA_G7 = {
  value: 0x18f,
  name: "G7 CGM Data Sample",
  format: "sby.ysi....",
  fields: ["status", "type", "rate", "rssi", "value", "timestamp"],
  postprocess: rec => rec,
  schema: cgmDataSampleSchema,
} as const satisfies TandemEventDefinition<CgmDataSamplePayload, CGMDexcomDataEvent>;
